const detail = [
    {
      path: '/notice',
      name: 'components-notice',
      hidden: true,
      component: () => import('../components/notice.vue'),
      meta: {
        title: 'notice'
      }
    },
    {
      path: '/mpWeiXin',
      name: 'mpWeiXin',
      hidden: true,
      meta: {
        title: '物流源',
        keepAlive: false
      },
      component: () => import('@/ivews/detail/mpWeiXin.vue')
    }
]
export default detail



// WEBPACK FOOTER //
// ./src/router/detail.js